import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createdDate: {
    description: 'Fulfillments Grid, Created Date Column Header',
    defaultMessage: 'Created Date',
    id: 'xRMOvC',
  },
  status: {
    description: 'Fulfillments Grid, Status Column Header',
    defaultMessage: 'Status',
    id: '2V9fMG',
  },
  shipDate: {
    description: 'Fulfillments Grid, Ship Date Column Header',
    defaultMessage: 'Ship Date',
    id: 'QSOns7',
  },
  orderNumber: {
    description: 'Fulfillments Grid, Order Number Column Header',
    defaultMessage: 'Order #',
    id: 'Pujvg4',
  },
  quantity: {
    description: 'Fulfillments Grid, Quantity Column Header',
    defaultMessage: 'Quantity',
    id: '5UOowW',
  },
  batchName: {
    description: 'Fulfillments Grid, Batch Column Header',
    defaultMessage: 'Batch',
    id: 'N8ERF8',
  },
  trackingNumber: {
    description: 'Fulfillments Grid, Tracking Number Column Header',
    defaultMessage: 'Tracking #',
    id: 'VKrefo',
  },
  external: {
    description: 'Fulfillments Grid, Provider Column External Provider',
    defaultMessage: 'External',
    id: 'I4aWvc',
  },
  provider: {
    description: 'Fulfillments Grid, Provider Column Header',
    defaultMessage: 'Provider',
    id: 'WNN+ao',
  },
  service: {
    description: 'Fulfillments Grid, Service Column Header',
    defaultMessage: 'Service',
    id: '/TZShP',
  },
  recipient: {
    description: 'Fulfillments Grid, Recipient Column Header',
    defaultMessage: 'Recipient',
    id: 'mKM2L7',
  },
  city: {
    description: 'Fulfillments Grid, City Column Header',
    defaultMessage: 'City',
    id: 'fUrbKM',
  },
  state: {
    description: 'Fulfillments Grid, State Column Header',
    defaultMessage: 'State',
    id: '7IpqFh',
  },
  country: {
    description: 'Fulfillments Grid, Country Column Header',
    defaultMessage: 'Country',
    id: 'zT0m+9',
  },
  amountPaid: {
    description: 'Fulfillments Grid, Amount Paid Cloumn Header',
    defaultMessage: 'Amount Paid',
    id: 'Ym/JpW',
  },
  assignedTo: {
    description: 'Fulfillments Grid, Assigned To Cloumn Header',
    defaultMessage: 'Assigned To',
    id: 'K0J0Pa',
  },
  carrier: {
    description: 'Fulfillments Grid, Carrier Column Header',
    defaultMessage: 'Carrier',
    id: '3HePef',
  },
  company: {
    description: 'Fulfillments Grid, Company Column Header',
    defaultMessage: 'Company',
    id: 'zQ6iqP',
  },
  delegationDate: {
    description: 'Fulfillments Grid, Delegation Date Column Header',
    defaultMessage: 'Delegation Date',
    id: 'kDDmuW',
  },
  deliveryNotification: {
    description: 'Fulfillments Grid, Delivery Notification Column Header',
    defaultMessage: 'Delivery Notification',
    id: '5Q1xgY',
  },
  orderDate: {
    description: 'Fulfillments Grid, Order Date Column Header',
    defaultMessage: 'Order Date',
    id: 'nIKBoZ',
  },
  packingSlipPrinted: {
    description: 'Fulfillments Grid, Packing Slip Printed Cloumn Header',
    defaultMessage: 'Packing Slip Printed',
    id: 'SQ1rFM',
  },
  printed: {
    description: 'Fulfillments Grid, Packing Slip Printed Column, Printed',
    defaultMessage: 'Printed',
    id: 'lGwq5b',
  },
  paidDate: {
    description: 'Fulfillments Grid, Paid Date Column Header',
    defaultMessage: 'Paid Date',
    id: 'lQbd4F',
  },
  postalCode: {
    description: 'Fulfillments Grid, Postal Code Column Header',
    defaultMessage: 'Postal Code',
    id: 'S87eiz',
  },
  shipmentNumber: {
    description: 'Fulfillments Grid, Shipment Number Column Header',
    defaultMessage: 'Shipment #',
    id: 'bVd/Lt',
  },
  shippingPaid: {
    description: 'Fulfillments Grid, Shipping Paid Column Header',
    defaultMessage: 'Shipping Paid',
    id: 'ZhtGTi',
  },
  source: {
    description: 'Fulfillments Grid, Source Column Header',
    defaultMessage: 'Source',
    id: 'ecLcN+',
  },
  store: {
    description: 'Fulfillments Grid, Store Column Header',
    defaultMessage: 'Store',
    id: 'QA9wYI',
  },
  taxPaid: {
    description: 'Fulfillments Grid, Tax Paid Column Header',
    defaultMessage: 'Tax Paid',
    id: 'UO4EU+',
  },
  weight: {
    description: 'Fulfillments Grid, Weight Column Header',
    defaultMessage: 'Weight',
    id: '15ZVGJ',
  },
  labelCreated: {
    description: 'Fuflillments Grid, Label Created Column Header',
    defaultMessage: 'Label Created',
    id: 'hw5Q14',
  },
  created: {
    description: 'Fulfillments Grid, Label Created Column, Created',
    defaultMessage: 'Created',
    id: 'Y2PeA+',
  },
  cancelled: {
    description: 'Fulfillments Grid, Status Column, Cancelled',
    defaultMessage: 'Cancelled',
    id: '/Wlggj',
  },
  delivered: {
    description: 'Fulfillments Grid, Status Column, Delivered',
    defaultMessage: 'Delivered',
    id: '4YPb2F',
  },
  error: {
    description: 'Fulfillments Grid, Status Column, Error',
    defaultMessage: 'Error',
    id: 'E9Yqu3',
  },
  shipped: {
    description: 'Fulfillments Grid, Status Column, Shipped',
    defaultMessage: 'Shipped',
    id: '1+nbFT',
  },
  pendingCancellation: {
    description: 'Fulfillments Grid, Status Column, Pending Cancellation',
    defaultMessage: 'Pending Cancellation',
    id: 'l8vSgH',
  },
  submitted: {
    description: 'Fulfillments Grid, Status Column, Submitted',
    defaultMessage: 'Submitted',
    id: 'dxIXXz',
  },
  marketplaceNotified: {
    description: 'Fulfillments Grid, Status Column, Marketplace Notified',
    defaultMessage: 'Marketplace Notified',
    id: 'gXTFjo',
  },
  marketplaceNotification: {
    description: 'Fulfillments Grid, Filters, Marketplace Notification',
    defaultMessage: 'Marketplace Notification',
    id: '1dJxBW',
  },
  notified: {
    description: 'Fulfillments Grid, Status Column, Notified',
    defaultMessage: 'Notified',
    id: 'uqDgxi',
  },
  shipmentNotification: {
    description: 'Fulfillments Grid, Status Column, Shipment Notification',
    defaultMessage: 'Shipment Notification',
    id: 'JZohJP',
  },
  sent: {
    description: 'Fulfillments Grid, Status Column, Sent',
    defaultMessage: 'Sent',
    id: 'WOQLKJ',
  },
  markedAsShippedProvider: {
    description: 'Fulfillments Grid, Providers Column, Order was manually marked as "sent" by the user',
    defaultMessage: 'Marked as Shipped',
    id: 'WzV4WA',
  },
  unknownProvider: {
    description: 'Fulfillments Grid, Providers Column, Unknown Provider',
    defaultMessage: 'Unknown',
    id: 'yIA2i5',
  },
  destination: {
    description: 'Fulfillments Grid, Destination Column Header',
    defaultMessage: 'Destination',
    id: 'kmp/Do',
  },
});
